import { judgeService, userService } from "../_services";

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,

  state: {
    users: {
      list: [],
      status: status.INITIAL
    },
    grants: {
      list: [],
      status: status.INITIAL
    },
    judges: {
      list: [],
      status: status.INITIAL
    },
    currentUser: null,
    authUser: null,

    selectedRole: null
  },

  getters: {
    users: ({ users }) => users.list,
    isUsersLoaded: ({ users }) => users.status == status.LOADED,

    grants: ({ grants }) => grants.list,
    isGrantsLoaded: ({ grants }) => grants.status == status.LOADED,

    judges: ({ judges }) => judges.list.sort((a, b) => a.lastName.localeCompare(b.lastName)),
    isJudgesLoaded: ({ judges }) => judges.status == status.LOADED,

  },
  mutations: {

    // Current functional
    setUsers: ({ users }, payload) => {
      users.list = payload
    },
    setUsersStatus: ({ users }, status) => {
      users.status = status
    },

    setUserInUsers: ({ users }, user) => {
      users.list.push(user)
    },

    setCurrentUser: (state, payload) => {
      state.currentUser = payload
    },

    setAuthUser: (state, payload) => {
      state.authuser = payload
    },

    setGrants: ({ grants }, payload) => {
      grants.list = payload
    },
    setGrantsStatus: ({ grants }, status) => {
      grants.status = status
    },

    setJudges: ({ judges }, payload) => {
      judges.list = payload
    },
    setJudgesStatus: ({ judges }, status) => {
      judges.status = status
    },

    selectRole: ( state , payload) => {
      state.selectedRole = payload
    }
    
  },
  actions: {
    INIT: ({ dispatch }) => {
      dispatch('LOAD_USERS')
      dispatch('LOAD_GRANTS')
      dispatch('LOAD_JUDGES')
    },

    LOAD_USERS: ({ state, commit }) => {
      if (state.users.status == status.INITIAL) {
        commit('setUsersStatus', status.LOADING)
        userService.userList().then(data => {
          commit('setUsers', data)
          commit('setUsersStatus', status.LOADED)
        })
      }
    },

    LOAD_GRANTS: ({ state, commit }) => {
      if (state.grants.status == status.INITIAL) {
        commit('setGrantsStatus', status.LOADING)
        userService.grantList().then(data => {
          commit('setGrants', data)
          commit('setGrantsStatus', status.LOADED)
        })
      }
    },

    LOAD_JUDGES: ({ commit }) => {
      judgeService.list().then(data => {
        commit('setJudges', data)
      })
    },

    LOAD_USER: ({ commit }, id) => {
      userService.userList().then(data => {
        data.map(user => {
          if (user.id == id)
            commit('setCurrentUser', user)
        })
      })
    },

    GET_AUTH_USER: ({ commit }) => {
      userService.getUserAuth().then(data => {
          commit('setAuthUser', data)
      })
    },
  }
}